module.exports = __WEBPACK_EXTERNAL_MODULE_140__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/net/URLLoader","root":["openfl","net","URLLoader"],"commonjs":"openfl/net/URLLoader","commonjs2":"openfl/net/URLLoader"}
// module id = 140
// module chunks = 0